// src/services/api.js
import axios from 'axios';
import { useToast } from 'vue-toastification'; // ایمپورت Toast
import { importKeyFromBase64, decryptWithKey,encryptWithKey } from '@/utils/crypto';

const toast = useToast();

const FIXED_KEY_B64 = 'PqY4JvE1bHqj9o7W2t9xC7T9JHgPf5J3NwLQ8xM4r2E='; 
let KEYOBJ = null;


(async () => {
  KEYOBJ = await importKeyFromBase64(FIXED_KEY_B64);
})();

// تولید مقادیر تصادفی برای secret و hash
function generateRandomParams() {
  return {
    secret: Math.random().toString(36).substring(2, 15), // تولید رشته تصادفی
    hash: Math.random().toString(36).substring(2, 15), // تولید رشته تصادفی
  };
}

const api = axios.create({
  baseURL: '', // خواندن baseUrl از Vuex
  timeout: 30000,
});

// افزودن توکن به هدر درخواست‌ها
api.interceptors.request.use( async (config) => {
  const store = require('@/store').default;
  // تنظیم baseURL از Vuex
  config.baseURL = store.getters.getBaseUrl;
  
  const token = store.getters.getAuthToken; // خواندن token از Vuex
  const nodeUid = store.getters.getNodeUid; // خواندن node_uid از Vuex

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
   // افزودن node_uid به پارامترهای کوئری (اگر مقدار آن پر باشد)
   if (nodeUid) {
    config.params = {
      ...config.params, // حفظ پارامترهای قبلی
      node_uid: nodeUid,
    };
  }

  // افزودن rand و hash به پارامترهای درخواست
  const { secret, hash } = generateRandomParams();
  config.params = {
    ...config.params, // حفظ پارامترهای قبلی
    secret,
    hash,
  };
  // ⚙️ اگر گزینه‌ی encrypt فعال باشه => داده‌ها رمزنگاری می‌شن
  if (config.encrypt && config.data && KEYOBJ) {
    try {
      const encrypted = await encryptWithKey(KEYOBJ, JSON.stringify(config.data));
      config.data = encrypted; // همون ساختار { ciphertext, iv, tag }
      config.headers['X-Encrypted'] = '1'; // هدر مخصوص برای سرور
    } catch (e) {
      console.error('Encryption failed:', e);
      toast.error('خطا در رمزگذاری داده‌ها');
    }
  }

  return config;
}, (error) => {
  return Promise.reject(error);
});

// مدیریت پاسخ‌ها
api.interceptors.response.use(
  async (response) => {
    const { data } = response;

    if (data && data.success && data.data && data.encrypted && KEYOBJ) {
      try {
        const plain = await decryptWithKey(KEYOBJ, data.data);
        response.data.data = JSON.parse(plain);
      } catch (e) {
        console.error('Decryption failed:', e);
        toast.error('مشکل در رمزگشایی داده‌ها');
      }
    }

    // بررسی اگر messages در پاسخ موجود باشد و آرایه‌اش پر باشد
    if (response.data && Array.isArray(response.data.messages) && response.data.messages.length > 0) {
      const isSuccess = response.data.success; // مقدار success از پاسخ
      response.data.messages.forEach((msg) => {
        // نمایش پیام‌ها بر اساس success
        if (isSuccess) {
          toast.success(msg); // پیام سبز
        } else {
          toast.error(msg); // پیام قرمز
        }
      });
    }
    return response;
  },
  (error) => {
    // مدیریت خطاها
    if (error.response) {
      if (error.response.data && Array.isArray(error.response.data.messages) && error.response.data.messages.length > 0) {
        const isSuccess = error.response.data.success; // مقدار success از پاسخ
        error.response.data.messages.forEach((msg) => {
          // نمایش پیام‌ها بر اساس success
          if (isSuccess) {
            toast.success(msg); // پیام سبز
          } else {
            toast.error(msg); // پیام قرمز
          }
        });
      }else{
        toast.error(`خطا: ${error.response.status} - ${error.response.data.message || 'مشکلی پیش آمد.'}`);
      }
    } else if (error.request) {
      toast.error('ارتباط با سرور برقرار نشد.');
    } else {
      toast.error(`خطای ناشناخته: ${error.message}`);
    }
    return Promise.reject(error);
  }
);

export default api;
